import { createRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/features/dashboard/dashboard-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/` — Tableau de bord (`02` §2). Fichier conservé sous son nom historique
 * (`dashboard-placeholder.tsx`) : `src/router.tsx` importe déjà
 * `dashboardIndexRoute` depuis ce chemin exact (câblé par la vague 5A) et
 * cette vague ne peut pas modifier `router.tsx` pour suivre un renommage —
 * seul le contenu a changé, le placeholder posé par 5A est remplacé par
 * l'écran réel (`features/dashboard/dashboard-page.tsx`).
 */
export const dashboardIndexRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/',
  component: DashboardPage,
});
